module.exports = __webpack_public_path__ + "img/deskshelf21.765dd4e1.jpg";